export enum NotificationModalType {
    Script = 'Script'
}
